import { i18n } from '@/locales';
import { currency } from '@/utils';
const t = i18n.t.bind(i18n);
const lc = 'views.allocated_cancel_penalty_group_setting.';
export const allocatedCancelPenaltyGroupSettingGroupTableHeader = [
    {
        title: t(`${lc}group_setting_table.group_name`),
        align: 'start',
        sortable: true,
        value: 'name',
    },
    {
        title: t(`${lc}group_setting_table.worker_in_group`),
        align: 'center',
        sortable: false,
        width: 150,
    },
    {
        title: t(`${lc}group_setting_table.edit_and_delete`),
        align: 'center',
        sortable: false,
        width: 130,
    },
];
export const allocatedCancelPenaltyGroupSettingOptionTableHeader = [
    {
        title: t(`${lc}option_setting_table.penalty_start_count`),
        align: 'end',
        sortable: false,
        width: 340,
    },
    {
        title: t(`${lc}option_setting_table.penalty_amount`),
        align: 'end',
        sortable: false,
        width: 340,
    },
    {
        title: t(`${lc}option_setting_table.edit`),
        align: 'center',
        sortable: false,
        width: 110,
    },
];
export const penaltyGroupWorkerListTableHeader = [
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_name`),
        align: 'start',
        sortable: false,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_code`),
        align: 'start',
        sortable: false,
        width: 94,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_number`),
        align: 'start',
        sortable: false,
        width: 120,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.delete`),
        align: 'center',
        sortable: false,
        width: 96,
    },
];
export const availableWorkerListTableHeader = [
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_name`),
        align: 'start',
        sortable: false,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_code`),
        align: 'start',
        sortable: false,
        width: 94,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_number`),
        align: 'start',
        sortable: false,
        width: 120,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.group_name`),
        align: 'start',
        sortable: false,
        width: 180,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.add`),
        align: 'center',
        sortable: false,
        width: 96,
    },
];
const allocatedCancelPenaltyGroupPenaltyAmountOptionList = [
    0,
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900,
    1000,
];
const result = {};
allocatedCancelPenaltyGroupPenaltyAmountOptionList.forEach((code) => {
    result[code] = {
        text: currency(code),
        value: code,
    };
});
export const penaltyAmountOption = result;
